import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncate',
  pure: true
})
export class TruncatePipe implements PipeTransform {

  transform(value: any, limit: number = 10): string {
    if (typeof value !== 'string') {
      return value; // If the value is not a string, return it as is
    }
    if (!value) {
      return ''; // Handle null or undefined value
    }
    if (value.length <= limit) {
      return value; // Return the string as is if it's shorter than the limit
    }
    return value.substring(0, limit) + '...'; // Truncate the string and add ellipsis
  }

}
